import { LocalizedText } from '@common/models';
import { NotfDateRangeApi } from './notf-date-range-api';
import { AlertType } from '../../domain/models/alert-type';

export class AlertApi
{
    id: string;
    active: boolean;
    createdAt: string | null;
    title: LocalizedText;
    text: LocalizedText;
    rangeActivation: NotfDateRangeApi;
    type: AlertType | null;
    backgroundColor: string | null;
}

